import React from 'react';
import {Link as RouterLink} from "react-router-dom";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem'

export default function NoraAppBarScreen(props) {
  const { t ,i18n} = useTranslation(['categoryLabel', 'common']);

  /* handler for language change */
  const handleLangChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

return (
  <>
  <Stack direction="column" sx={{pb:5}}>
    <Stack direction="row" >
    
    <Typography
      noWrap
      variant="h3"
      component={RouterLink}
      to="/"
      sx={{
        mr:2,
        ml:0,
        mt:1,
        display: { xs: 'none', md: 'flex' },
        flexGrow: 1,
        fontWeight: 'bold',
        color: 'black',
        textDecoration: 'none',

      }}
    >
      Nora Vest
    </Typography>
    <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
      {props.pages.map((page) => (
        <Button
          key={page.id}
          component={RouterLink} to={page.id}
          sx={{ my: 2, color: 'black', display: 'block' ,fontFamily: 'sans-serif',fontSize:'1.2em',fontWeight:(page.id===props.selected)?'700':'500',textTransform: "none"}}
        >
          {t(page.key)}
        </Button>
      ))}
      <FormControl variant="standard">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={i18n.language}
            onChange={handleLangChange}
            sx={{border:'none',marginTop:'25px',marginLeft:'10px'}}
          >
            <MenuItem value={'de'}>Deutsch</MenuItem>
            <MenuItem value={'en'}>English</MenuItem>
          </Select>
        </FormControl>
    </Box>
    </Stack>
    <Typography
      variant="h5"
      noWrap
      sx={{
        mr: 2,
        display: { xs: 'none', md: 'flex' },
        flexGrow: 1,
        fontWeight: 'bold',
        color: 'black',
        textDecoration: 'none',
      }}
    >
      {props.title}
    </Typography>
    </Stack>
  </>
)
}